/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { IOrderConfig } from '@estee/elc-layouts';
import { IAccountLayouts, IFeature, OrderConfigTuple } from '~components/interfaces';

export const loadOnDemand = (viewFunction: Function, viewParams: IFeature | {} = {}) => () =>
    React.createElement(viewFunction as any, viewParams as any);

const pad = (name: string) => [' ', name, ' '].join('');
const getMultipleSections = (sameRow: OrderConfigTuple[]) =>
    sameRow
        .map(
            ([name, section]: OrderConfigTuple) =>
                `${pad(name).repeat(section?.params?.position?.spaces)}`
        )
        .join(' ');

const getSingleSections = (components: OrderConfigTuple[]) =>
    components.map(([sectionName]) => `'. ${pad(sectionName as string)} .'`).join('');

const sortByRowThenOrder = ([, a]: OrderConfigTuple, [, b]: OrderConfigTuple) => {
    const positionA = a?.params?.position;
    const positionB = b?.params?.position;

    return positionA?.row - positionB?.row || positionA?.order - positionB?.order;
};

export const createSingleGridLayout = (
    componentConfig: IOrderConfig = {}
): IAccountLayouts['smallLayout'] => {
    const sorted = Object.entries(componentConfig).sort(sortByRowThenOrder);

    return getSingleSections(sorted);
};

export const createMultiGridLayout = (componentConfig: IOrderConfig = {}): IAccountLayouts => {
    const sorted = Object.entries(componentConfig).sort(sortByRowThenOrder);
    const smallLayout = getSingleSections(sorted);

    const largeLayout = sorted.reduce((grid, component) => {
        const [, section] = component;
        const sameRow = sorted.filter(
            ([, item]) => item?.params?.position?.row === section?.params?.position?.row
        );

        const multipleSections = getMultipleSections(sameRow);
        const hasSection = grid.includes(multipleSections);

        if (!hasSection) {
            // eslint-disable-next-line no-param-reassign
            grid += `'. ${multipleSections} .'`;
        }

        return grid;
    }, '');

    return { smallLayout, largeLayout };
};

export let sidebarLastSection: string;

export const createSidebarLayout = (componentConfig: IOrderConfig): string => {
    const sorted = Object.entries(componentConfig).sort(sortByRowThenOrder);

    sidebarLastSection = sorted[sorted.length - 1]?.[0];

    return sorted.reduce((grid, component) => {
        const [sectionName] = component;

        return `${grid}'${sectionName}'`;
    }, '');
};
